import type { ConfigProvider } from '../config-provider';
import type { defaultConfig } from '../default-config';

const configMap: Record<string, Partial<typeof defaultConfig>> = {
    local: {},
    sandbox: {},
};

export const envConfigProvider: ConfigProvider = (key) => {
    if (!import.meta.env.VITE_APP_ENV) {
        return;
    }

    return configMap[import.meta.env.VITE_APP_ENV]?.[key];
};
